import React from "react";
import { Link, useLocation } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { MdClose } from "react-icons/md";
import { elakayAutoText } from "../../includes/pageInside/dataElakay";
import { buildDrawerNav, findActiveItemKey, GROUP_ICON, statusLabel } from "./drawerNav";
import "../../includes/pageInside/Filters.css";
import "./DrawerNavGroups.css";

// NAVIGATION groups of the Filter drawer. Built from drawerNavConfig for the EFFECTIVE role, so Royalty
// gets nothing, Seller gets Dropshipping In, Provider gets Provider / Producer, Associate -> Family get
// both. Uses the Accordion + SideDrawer1-filter-* look of the existing Filter drawer, React Router
// links (no page reload) and closes the drawer after a choice.
// Dropdown rule: both groups are CLOSED whenever the drawer opens (never derived from the active route),
// only ONE can be open at a time (single `openSection` state), and clicking the open one closes it.
// The active route is shown by highlighting (group header + item), not by opening the group.
export default function DrawerNavGroups({ infoSource, click, showClose = true, resetKey, displayMode = null }) {
  const [openSection, setOpenSection] = React.useState(null);
  React.useEffect(() => { setOpenSection(null); }, [resetKey]);
  const { pathname } = useLocation();
  const groups = React.useMemo(() => buildDrawerNav(infoSource), [infoSource, infoSource?.allSettings, infoSource?.userInfo]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!groups.length) return null;
  const navLabel = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.drawerNavigation?.navigation || "Navigation";

  return (
    <div className="SideDrawer1-filters-container-modern dnav" data-testid="drawer-nav">
      <div className="SideDrawer1-filters-header">
        <div className="SideDrawer1-filters-header-content">
          <div>
            <span className="SideDrawer1-filters-eyebrow">ELAKAY</span>
            <h3 className="SideDrawer1-filters-title">{navLabel}</h3>
          </div>
        </div>
        {showClose && <button type="button" className="SideDrawer1-filters-close-btn" onClick={click} aria-label={elakayAutoText("h_c2db1e0ed9c89b", "Close filters")}><MdClose /></button>}
      </div>
      {/* Portrait / Landscape: a display setting of Elakay Navigation, not a filter */}
      {displayMode}
      <Accordion activeKey={openSection} onSelect={(key) => setOpenSection(key ?? null)} className="SideDrawer1-filters-accordion dnav__accordion">
        {groups.map((group) => {
          const Icon = GROUP_ICON[group.key];
          const activeItem = findActiveItemKey(group, pathname);
          return (
            <Accordion.Item eventKey={group.key} key={group.key} className={`SideDrawer1-filter-item${activeItem ? " dnav__group--active" : ""}`}>
              <Accordion.Header className="SideDrawer1-filter-header">
                {Icon && <Icon className="SideDrawer1-filter-header-icon" />}
                <span className="SideDrawer1-filter-header-text">{group.label}</span>
              </Accordion.Header>
              <Accordion.Body className="SideDrawer1-filter-body">
                <ul className="dnav__list" aria-label={group.label}>
                  {group.items.map((item) => {
                    const ItemIcon = item.icon;
                    const active = activeItem === item.key;
                    const inert = item.status !== "active";
                    return (
                      <li key={item.key}>
                        {inert ? (
                          <span className="dnav__link dnav__link--inert" aria-disabled="true"><ItemIcon aria-hidden="true" /><span className="dnav__label">{item.label}</span><span className="dnav__badge">{statusLabel(infoSource, item.status)}</span></span>
                        ) : (
                          <Link to={item.route} onClick={click} className={`dnav__link${active ? " is-active" : ""}`} aria-current={active ? "page" : undefined}><ItemIcon aria-hidden="true" /><span className="dnav__label">{item.label}</span></Link>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}
